const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-live-stream'] = {
        c: () => require('partner/modules/ecomm-live-stream/ecomm-live-stream.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-live-stream',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-live-stream'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-live-stream|ecomm-live-stream'] = {
                c: () => require('partner/modules/ecomm-live-stream/ecomm-live-stream.view.tsx'),
                cn: '__local__-__local__-ecomm-live-stream'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };